module.exports = __webpack_public_path__ + "static/media/mobile_filter_active.6ba78e5c.svg";